import React from 'react';
import "./header.scss";
import Grid from '@material-ui/core/Grid';
import JerseyCrest from '../../images/Gov-Jersey-Crest.svg'
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  menuHeader: {
    fontWeight:"bold", 
    fontSize:"14px",
    textAlign:"left",
    paddingLeft:"15px"
  },
  linkText: {
    color: '#b60011',
    fontFamily:'proxima-nova,sans-serif',
    fontSize:'16px',
    textDecoration:'underline',
    fontWeight:"700",
    borderTop:"1px solid lightgrey"
  },
  subText: {
    fontSize: 'small', 
    fontWeight: 300, 
    paddingLeft:"15px",
    marginBottom:"10px",
    textAlign:"left",
    marginTop:"0",
    paddingRight:"15px"
  },
  paperStyle: {
    borderRadius:"0px",
    border:"1px solid lightgrey",
  },
  loginButton: {
    color:"white", 
    padding:"0", 
    minWidth:"auto",
    "&:focus-visible": {
      backgroundColor: "hsl(208, 89%, 34%) !important",
      color: "#fff !important"
      }
  }
}));


const Header = () => {

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const mobileVP = useMediaQuery('(min-width:768px)');
  const loginDesktop = useMediaQuery('(max-width:1000px)');

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <header className="siteHeader">

      <Grid container>
        <Grid item xs={7} md={8}>
          <div id="masthead">
            <a href="/">
              <img src={JerseyCrest} alt="Home"/>gov.je</a>
            <p id="mastheadText">Information and public services for the Island of Jersey<br />
            <span id="mastheadSubText">L'&#238;nform&#226;tion et les s&#232;rvices publyis pouor I'&#206;le d&#233; J&#232;rri</span></p>
          </div>
        </Grid>

        <Grid item xs={5} md={4} style={{textAlign:"right"}}>
          <div id="mastheadLinks">
            <ul>
              <li>
                <a href="https://www.gov.je/Pages/contacts.aspx" className="mastheadHidden mastText">Contacts</a>
              </li>
              <li>
                <a href="https://www.gov.je/Pages/TranslateSite.aspx" className="mastheadHidden mastText">Translate</a>
              </li>
              <li> 
              <Button
              className={classes.loginButton}
              ref={anchorRef}
              aria-controls={open ? 'menu-list-grow' : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              >
              <span style={{textTransform:"capitalize", fontWeight:700}} className="mastText">Login</span>
            </Button>
              </li>
            </ul>
          </div>
          {mobileVP && 
        <Popper style={{zIndex:"3"}}
        open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper style={loginDesktop ? {minWidth:"600px", position:"relative", left:"6px"} : {minWidth:"375px", position:"relative", left:"6px"}} className={classes.paperStyle}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <p className={classes.menuHeader}>Choose the service you want to log in to:</p>
                    <a href="https://www.gov.je/citizen/pages/login.aspx"><MenuItem className={classes.linkText}  onClick={handleClose}>gov.je</MenuItem></a>
                    <p className={classes.subText}>Update your notification preference</p>
                    <a href="https://id.gov.je/?ReturnUrl=%2FSaml%2FSSOServiceCompletion"><MenuItem className={classes.linkText} onClick={handleClose}>one.gov.je</MenuItem></a>
                    <p className={classes.subText}>Access government services</p>
                    <a href="https://www.customs.gst.gov.je/?_gl=1*1c2h3ta*_ga*MzMwMzQyNTgxLjE2MjM4MzI3MTQ.*_ga_07GM08Q17P*MTYzNDAzOTY1NC4xOC4xLjE2MzQwMzk4MTUuMA.."><MenuItem className={classes.linkText} onClick={handleClose}>CAESAR</MenuItem></a>
                    <p className={classes.subText}>Clear goods through customs or claim relief</p>
                    <a href="https://www.gov.je/Working/JobCareerAdvice/Pages/Login.aspx"><MenuItem className={classes.linkText} onClick={handleClose}>Talentlink</MenuItem></a>
                    <p className={classes.subText}>View or update your States of Jersey job application</p>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
        }
        </Grid>
        {!mobileVP && open &&
        <div style={{width:"100%"}}>
          <Paper className={classes.paperStyle}>
                <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    <p className={classes.menuHeader}>Choose the service you want to log in to:</p>
                    <a href="https://www.gov.je/citizen/pages/login.aspx"><MenuItem className={classes.linkText}  onClick={handleClose}>gov.je</MenuItem></a>
                    <p className={classes.subText}>Update your notification preference</p>
                    <a href="https://id.gov.je/?ReturnUrl=%2FSaml%2FSSOServiceCompletion"><MenuItem className={classes.linkText} onClick={handleClose}>one.gov.je</MenuItem></a>
                    <p className={classes.subText}>Access government services</p>
                    <a href="https://www.customs.gst.gov.je/?_gl=1*1c2h3ta*_ga*MzMwMzQyNTgxLjE2MjM4MzI3MTQ.*_ga_07GM08Q17P*MTYzNDAzOTY1NC4xOC4xLjE2MzQwMzk4MTUuMA.."><MenuItem className={classes.linkText} onClick={handleClose}>CAESAR</MenuItem></a>
                    <p className={classes.subText}>Clear goods through customs or claim relief</p>
                    <a href="https://www.gov.je/Working/JobCareerAdvice/Pages/Login.aspx"><MenuItem className={classes.linkText} onClick={handleClose}>Talentlink</MenuItem></a>
                    <p className={classes.subText}>View or update your States of Jersey job application</p>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
        </div>
        }
      </Grid>
          
    </header>
  )
}

export default Header;
